// extracted by mini-css-extract-plugin
module.exports = {"NewsPage_byline":"NewsPage_NewsPage_byline__12-ga","NewsPage_wrapper":"NewsPage_NewsPage_wrapper__1ELLv"};